<phx-card-base
  [phxHeader]="!phxHideHeader ? header : null"
  [phxBody]="body">
</phx-card-base>

<ng-template #body>
  <div class="phx-content-card-description-container">
    <ng-content select="[phx-content-description]"></ng-content>
  </div>
  <div class="phx-content-card-body-container">
    <ng-content select="[phx-content-card-body]"></ng-content>
  </div>
</ng-template>

<ng-template #header>
  <div class="phx-content-card-header">
    <div #title class="phx-content-card-title">
      <ng-content select="[phx-content-card-title]"></ng-content>
    </div>
    <div #actions class="phx-content-card-actions">
      <ng-content select="[phx-content-card-action-bar]"></ng-content>
    </div>
  </div>
</ng-template>